module.exports = __webpack_public_path__ + "videos/about-1025.642c720.webm";